/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('ProductCategory_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl + 'rest/productCategories/:id',{}, {
            query: { method: 'GET', isArray: false },
            getTree: { method: 'GET', isArray: false , url:baseUrl+'rest/productCategories/tree'},
            getTreeForDate: { method: 'GET', isArray: false , url:baseUrl+'rest/productCategories/tree/:date'},
            getDeleted: { method: 'GET', isArray: true , url:baseUrl+'rest/productCategories/deleted'},
            get:   { method: 'GET' }
        });
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('ProductCategory',["ProductCategory_Resource","Product","ProductCategoryData","ProductData","ImageData","CompanyImageData",
        function (ProductCategory_Resource,Product,ProductCategoryData,ProductData,ImageData,CompanyImageData)
    {
        var ProductCategory = function (rsProductCategory,parentCategory)
        {
            this.id = null;
            this.isDeleted;
            this.label = "";
            this.description = "";
            this.image = null;
            this.companyImage = null;
            this.specificImage;//boolean
            this.isVisibleOnWebSite;
            this.style = "";
            this.products = [];
            this.categories = [];
            this.parentCategoryId = null;
            this.version = null;

            if (parentCategory!==undefined && parentCategory!=null)
                this.parentCategory=  parentCategory;

            if (rsProductCategory!==undefined && rsProductCategory!=null)
            {
                var product,category;
                this.id = rsProductCategory.id;
                this.isDeleted = rsProductCategory.isDeleted;
                this.label = rsProductCategory.label;
                this.description = rsProductCategory.description;
                this.imageId =  rsProductCategory.imageId;
                this.companyImageId =  rsProductCategory.companyImageId;
                this.specificImage = rsProductCategory.specificImage;
                this.isVisibleOnWebSite = rsProductCategory.isVisibleOnWebSite;
                this.parentCategoryId =  rsProductCategory.parentCategoryId;
                this.style = rsProductCategory.style;

                if ( rsProductCategory.categories)
                    for (var i=0;i< rsProductCategory.categories.length;i++)
                    {
                        category = new ProductCategory(rsProductCategory.categories[i],this);
                        this.categories.push(category);
                    }

                if ( rsProductCategory.products)
                    for (var j=0;j< rsProductCategory.products.length;j++)
                    {
                        product = new Product(rsProductCategory.products[j],this);
                        this.products.push(product);
                    }
            }
            ProductCategoryData.add(this);
        }

        ProductCategory.prototype.loadObject = function(object,parentCategory)
        {
            this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.label = object.label;
            this.description = object.description;
            this.style= object.style;
            this.specificImage = object.specificImage;
            this.isVisibleOnWebSite = object.isVisibleOnWebSite;
            if (object.version)
                this.version = object.version;
            if (parentCategory!==undefined && parentCategory!=null)
            {
                this.parentCategory=  parentCategory;
            }

            //load ref from ids
            if (object.productsId)
            {
                var newProducts = [];
                for (var i=0;i<object.productsId.length;i++)
                {
                    var product =  ProductData.getById(object.productsId[i]);
                    if (product!=null)
                        newProducts.push(product);
                }
                this.products = newProducts;
            }
            if (object.productsId)
            {
                var newCategories = [];
                for (i=0;i<object.categoriesId.length;i++)
                {
                    var category =  ProductCategoryData.getById(object.categoriesId[i]);
                    if (category!=null)
                        newCategories.push(category);
                }
                this.categories = newCategories;
            }


        }
        ProductCategory.prototype.getObjectResource = function()
        {
            var rsProductCategory = new ProductCategory_Resource();
            rsProductCategory.id = this.id ;
            rsProductCategory.isDeleted = this.isDeleted;
            rsProductCategory.label =this.label;
            rsProductCategory.description =this.description;
            if (this.image)
                rsProductCategory.imageId = this.image.id;
            if (this.companyImage)
                rsProductCategory.companyImageId = this.companyImage.id;
            rsProductCategory.specificImage = this.specificImage;
            rsProductCategory.isVisibleOnWebSite = this.isVisibleOnWebSite;
            rsProductCategory.style = this.style;

            if (this.parentCategory)
                rsProductCategory.parentCategoryId = this.parentCategory.getId();
            rsProductCategory.categoriesId = [];
            for (var i=0;i< this.categories.length;i++)
                rsProductCategory.categoriesId.push( this.categories[i].getId());
            rsProductCategory.productsId = [];
            for (var i=0;i< this.products.length;i++)
                rsProductCategory.productsId.push(this.products[i].getId());
            return rsProductCategory;
        }
        ProductCategory.prototype.getId = function()
        {
            return this.id;
        }
        ProductCategory.prototype.setId = function(id)
        {
            this.id = id;
        }
        ProductCategory.prototype.getLabel = function()
        {
            return this.label;
        }
        ProductCategory.prototype.addProduct = function(product)
        {
            if (product)
            {
                var index = this.products.indexOf(product);
                if (index==-1)//Not already there
                {
                    this.products.push(product);
                    product.parentCategory = this;
                }
            }
        }
        ProductCategory.prototype.removeProduct = function(product)
        {
            var index = this.products.indexOf(product);
            if (index!=-1)//Found
            {
                this.products.splice(index,1);
            }

        }
        ProductCategory.prototype.addCategory = function(category)
        {
            if (category) {
                var index = this.categories.indexOf(category);
                if (index == -1)//Not already there
                {
                    this.categories.push(category);
                    category.parentCategory = this;
                }
            }
        }
        ProductCategory.prototype.removeCategory = function(category)
        {
            var index = this.categories.indexOf(category);
            if (index!=-1)//Found
            {
                this.categories.splice(index,1);
            }

        }        
        ProductCategory.prototype.changeProductPosition = function(product,indexTarget)
        {
            //Change the product position
            var index = this.products.indexOf(product);
            if (indexTarget!=-1 && index!=-1 && indexTarget!=index && this.products && indexTarget<this.products.length)
            {
                var cat = this.products[indexTarget];

                this.products.splice(index,1);
                if (index<indexTarget)
                    indexTarget--;
                this.products.splice(indexTarget,0,product);

            }

        }
        ProductCategory.prototype.getProductById =  function(productId)
        {
            //recursive research
            var product = null;
            for (var j = 0; j < this.products.length; j++)
                if (this.products[j].id == productId)
                    return this.products[j];
            for (var z=0;z< this.categories.length && !product;z++)
                product = this.categories[z].getProductById(productId);

            return product;
        }
        ProductCategory.prototype.getProductByLabel =  function(productLabel)
        {
            //recursive research, need lower case input
            var product = null;
            for (var j = 0; j < this.products.length; j++)
                if (this.products[j].label.toLowerCase() == productLabel)
                    return this.products[j];
            for (var z=0;z< this.categories.length && !product;z++)
                product = this.categories[z].getProductByLabel(productLabel);

            return product;
        }
        ProductCategory.prototype.getProductCategoryById =  function(categoryId)
        {
            //recursive research
            var category = null;
            for (var z=0;z< this.categories.length && !category;z++)
                if (this.categories[z].id == categoryId)
                    category= this.categories[z];
                else
                    category = this.categories[z].getProductCategoryById(categoryId);
            return category;
        }
        ProductCategory.prototype.loadRef =  function()
        {
            if (this.imageId)
                this.image = ImageData.getById(this.imageId);
            if (this.companyImageId)
                this.companyImage = CompanyImageData.getById(this.companyImageId);
            if (this.parentCategory==null && this.parentCategoryId)
                this.parentCategory = ProductCategoryData.getById(this.parentCategoryId);
        }
        ProductCategory.prototype.getSubStatCategories =  function(rootCategory)
        {
            return this.categories.concat(this.products);
        }

        ProductCategory.prototype.isDescendantOf = function(category) {
            var isDescendantOf = false;
            if(this.parentCategory === category) {
                isDescendantOf = true;
            }
            else {
                if(this.parentCategory) {
                    isDescendantOf = this.parentCategory.isDescendantOf(category);
                }
            }

            return isDescendantOf;
        }

        return ProductCategory;
    }
    ]);

angular.module('FlexyBeautyApp.services').factory('ProductCategorySrv', ["ProductCategory_Resource", "ProductCategory", "ProductCategoryData", "UserActionData",
    "ProductSrv", "$log", "ServerSrv", "LanguageManager",
    function (ProductCategory_Resource, ProductCategory, ProductCategoryData, UserActionData,
              ProductSrv, $log, ServerSrv, LanguageManager) {
        var categorySrv = {};
        categorySrv.query = function (successFunction, errorFunction) {
            var treeLoaded = false;
            var deletedLoaded = false;
            ProductCategory_Resource.getTree(
                {}, //params
                function (data) {   //success
                    ProductCategoryData.categoryRoot = new ProductCategory(data);

                    if (successFunction !== undefined && deletedLoaded)
                        successFunction(ProductCategoryData.categoryRoot);
                    treeLoaded = true;
                },
                function (data) {   //failure
                    $log.error("ProductCategory_Resource.getTree error");
                    $log.error(data);
                    if (errorFunction!== undefined && deletedLoaded)
                        errorFunction(data);
                    treeLoaded = true;
                });
            ProductCategory_Resource.getDeleted(
                {}, //params
                function (data) {   //success
                    ProductCategoryData.deletedCategories = [] ;
                    for (var i=0;i< data.length;i++)
                        new ProductCategory(data[i]);//Auto Add to ProductCategoryData

                    if (successFunction!== undefined && treeLoaded)
                        successFunction(ProductCategoryData.categoryRoot);
                    deletedLoaded = true;
                },
                function (data) {   //failure
                    $log.error("ProductCategory_Resource.getDeleted error");
                    $log.error(data);
                    if (errorFunction !== undefined && treeLoaded)
                        errorFunction(data);
                    deletedLoaded = true;

                }
            );
        };
        categorySrv.getTreeForDate = function (date, successFunction, errorFunction) {
            const formattedDateParam = ("0" + date.getDate()).slice(-2) + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + date.getFullYear();
            ProductCategory_Resource.getTreeForDate(
                {date: formattedDateParam}, //params
                function (productRoot) {
                    if (successFunction !== undefined)
                        successFunction(productRoot);
                },
                function (data) {   //failure
                    $log.error("ProductCategory_Resource.getTree error");
                    $log.error(data);
                    if (errorFunction !== undefined)
                        errorFunction(data);
                });
        };
        categorySrv.save = function(category,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(categorySrv.saveSync, category, successFunction, errorFunction);
        };
        categorySrv.saveSync = function(category,successFunction,errorFunction)
        {
            var ProductCategoryRes = category.getObjectResource();
            ProductCategoryRes.$save({}, //no params
                function (data) {
                    try {
                        category.setId(data.id);
                        if (!category.version || (data.version && data.version > category.version))
                            category.version = data.version;
                        //TODO  UserActionData.add(data.userAction);
                        if (successFunction) {
                            successFunction(data);
                        }
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        categorySrv.remove =  function(category,successFunction,errorFunction)
        {
            ProductCategoryData.remove(category);
            ServerSrv.startSavingProcess(categorySrv.removeSync, category, successFunction, errorFunction);
        };
        categorySrv.removeSync =  function(category,successFunction,errorFunction)
        {
            var categoryRes = new ProductCategory_Resource()
            categoryRes.$remove({id:category.getId()}, //params : id
                function (data) {
                    try {
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction != undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        categorySrv.restore =  function(category,successFunction,errorFunction)
        {
            ProductCategoryData.restore(category);
            ServerSrv.startSavingProcess(categorySrv.restoreSync, category, successFunction, errorFunction);
        };
        categorySrv.restoreSync =  function(category,successFunction,errorFunction)
        {
            var categoryRes = category.getObjectResource();
            categoryRes.$save({}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        categorySrv.getProductCategoryOnServer =  function(scope,targetName,categoryId)
        {

            var category = null
            if (ProductCategoryData.categoryRoot.categories!=null && ProductCategoryData.categoryRoot.categories.length>0)
            {
                for (var i=0;i<ProductCategoryData.categoryRoot.categories.length && !category;i++)
                    if (ProductCategoryData.categoryRoot.categories[i].getId()==categoryId)
                        category = ProductCategoryData.categoryRoot.categories[i];
                    else
                        for (var j=0;j<ProductCategoryData.categoryRoot.categories[i].categories.length && !category;j++)
                            if (ProductCategoryData.categoryRoot.categories[i].categories[j].getId()==categoryId)
                                category = ProductCategoryData.categoryRoot.categories[i].categories[j];
                scope[targetName] =  category;
            }
            else
            {
                ProductCategory_Resource.get(
                    {id:categoryId},
                    function (categoryRes) {   //success
                        scope[targetName] = new ProductCategory(categoryRes);
                    },
                    function (categoryRes) {   //failure
                        //error handling goes here
                    });
            }
        };
        categorySrv.get =  function(categoryId)
        {
            //TODO
            return null;
        };
        categorySrv.getProductById =  function(productId)
        {
            if (ProductCategoryData.categoryRoot!=null)
            return ProductCategoryData.categoryRoot.getProduct(productId);
        };
        categorySrv.loadRef =  function()
        {
            var categories = ProductCategoryData.indexCategories;
            for (var i=0;i<categories.length;i++)
                categories[i].loadRef();

        };
        categorySrv.moveProduct = function(category,product)
        {
            if (category)
            {
                category.moveProduct(product);
                ProductSrv.save(product);

            }
        };
        categorySrv.updateLocally =  function(id,object)
        {
            var category = null;
            var parentCategory = null;
            if (object.parentCategoryId)//Optimization : get parent if exist
            {
                parentCategory = ProductCategoryData.getById(object.parentCategoryId);
                if  (parentCategory!=null)
                    category = parentCategory.getProductCategoryById(id);
            }
            else
                category = ProductCategoryData.getById(id);
            if (category!=null)
                category.loadObject(object,parentCategory);
        };
        categorySrv.addLocally =  function(id,object)
        {
            //TODO
/*            var category = ProductCategoryData.getProductCategory(object.parentCategoryId);
            if (category!=null)
                category.addProduct(new Product(object,category));*/

        };
        categorySrv.removeLocally =  function(id,object)
        {
            //TODO
/*            var product =  null;
            var category = ProductCategoryData.getProductCategory(object.parentCategoryId);
            if (category!=null)
                product = category.getProduct(object.id)
            if (product!=null)
                category.removeProduct(product);*/
        };

        return categorySrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('ProductCategoryData',["$log", function ($log)
    {
        var  categoryData = 
        {
            categoryRoot : null,
            indexCategories : [], //Used as Index
            deletedCategories : []
        };
        categoryData.getById =  function(categoryId)
        {
            for (var i=0;i<this.indexCategories.length;i++)
                if (this.indexCategories[i].id==categoryId)
                    return this.indexCategories[i];
            return null;
        }
        categoryData.getByIndex =  function(catIndex)
        {
            if (catIndex>=0 && catIndex<this.indexCategories.length)
                return this.indexCategories[catIndex];
            else
                return null;
        }
        categoryData.getIndexOf =  function(category)
        {
            if (category)
                return this.indexCategories.indexOf(category);
            return -1;
        }
        categoryData.add =  function(category)
        {
            this.indexCategories.push(category);
            if (category.isDeleted)
            {
                var index = this.deletedCategories.indexOf(category)
                if (index==-1)
                    this.deletedCategories.push(category);
            }
            return this.indexCategories.length-1;
        }
        categoryData.remove =  function(category) //Soft Remove
        {
            var index =  this.deletedCategories.indexOf(category);
            if (index==-1)
            {
                this.deletedCategories.push(category)
                category.isDeleted=true;
            }

        }
        categoryData.restore =  function(category) //Soft Remove
        {
            var index =  this.deletedCategories.indexOf(category);
            if (index!=-1)
            {
                this.deletedCategories.splice(index,1)
                category.isDeleted=false;
            }

        }
        categoryData.clear =  function()
        {
            categoryData.categoryRoot = null;
            categoryData.indexCategories = [];
            categoryData.deletedCategories = [];
        }
        categoryData.loaded =  function()
        {
            return (categoryData.categoryRoot != null);
        }
        categoryData.getDeletedList =  function()
        {
            return categoryData.deletedCategories;
        }

        return categoryData;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/ProductCategory.js